var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        title: _vm.$t("login.invitationRegistration"),
        visible: _vm.registerDialog,
        top: "10vh",
        width: "750px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.registerDialog = $event
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-desc" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("login.invitationRegistrationInstruction")) + " "
        ),
      ]),
      _c("div", { staticClass: "dialog-content" }, [
        _c(
          "div",
          { staticClass: "link-section" },
          [
            _c("div", { staticClass: "link-text", on: { click: _vm.toLink } }, [
              _vm._v(_vm._s(_vm.registerLink)),
            ]),
            _c(
              "el-button",
              {
                staticClass: "copy-btn",
                attrs: { icon: "el-icon-document", size: "small" },
                on: { click: _vm.copyLink },
              },
              [_vm._v(" " + _vm._s(_vm.$t("login.copyLink")) + " ")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "qrcode-section" },
          [
            _c("div", {
              ref: "qrcodeContainer",
              staticClass: "qrcode-box",
              staticStyle: { width: "150px", height: "150px" },
            }),
            _c(
              "el-button",
              {
                staticClass: "copy-btn",
                staticStyle: { "margin-top": "10px" },
                attrs: { icon: "el-icon-document", size: "mini" },
                on: { click: _vm.copyQrcode },
              },
              [_vm._v(" " + _vm._s(_vm.$t("login.copyQrCode")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "dialog-tip" }, [
        _vm._v(_vm._s(_vm.$t("login.encryptedTamperProofNotice"))),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.closeBtn } },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Close")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }